<template>
    <div class="box shadow" v-loading="loading">
        <h3>Что видят на вашей странице другие участники</h3>
        <div class="meta-box">
            <ModelSwitch
                label="Закрытый профиль"
                v-model="isPrivatePage"
                @change="updateIsPrivatePage"
            />
            <div class="tooltip-wrapper">
                <div class="tooltip-action"/>
                <div class="tooltip-details">
                    Закрытый профиль полностью скрыт от других участников и не отображается в поиске платформы
                </div>
            </div>
        </div>
        <Folder
            class="folder"
            v-for="block in tree"
            :title="block.title"
            :key="block.key"
            :class="{ 'flex-4': block.flex === 4, 'flex-3': block.flex === 3, 'flex-2': [2, 'meta'].includes(block.flex) }"
            new-folder
        >
            <div class="block" :class=" { meta: block.flex === 'meta' } ">
                <template v-if="block.flex === 'meta'">
                    <div class="checkboxes">
                        <div
                            v-for="item in block.items"
                            :key="item.key"
                            class="item"
                        >
                            <ModelCheckbox
                                v-if="block.type === 'checkbox'"
                                :label="item.label"
                                v-model="item.value"
                                :disabled="isPrivatePage"
                                @change="updateToApi(item.value, item.key, item.api, item.id)"
                            />
                            <ModelSwitch
                                v-else
                                :label="item.label"
                                v-model="item.value"
                                :disabled="isPrivatePage"
                                @change="updateToApi(item.value, item.key, item.api, item.id)"
                            />
                        </div>
                    </div>
                    <div class="info" v-if="block.flex === 'meta'">
                        {{ block.meta }}
                    </div>
                </template>
                <template v-else>
                    <div
                        v-for="item in block.items"
                        :key="item.key"
                        class="item"
                    >
                        <ModelCheckbox
                            v-if="block.type === 'checkbox'"
                            :label="item.label"
                            v-model="item.value"
                            :disabled="isPrivatePage"
                            @change="updateToApi(item.value, item.key, item.api, item.id)"
                        />
                        <ModelSwitch
                            v-else
                            :label="item.label"
                            v-model="item.value"
                            :disabled="isPrivatePage"
                            @change="updateToApi(item.value, item.key, item.api, item.id)"
                        />
                    </div>
                </template>
            </div>
        </Folder>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Folder from '@/components/UI/Folder';
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import ModelSwitch from '@/components/UI/models/ModelSwitch';

const newUsersGetters = [
    'getUserHiddenFieldsProjects',
    'getUserHiddenFieldsProgress',
    'getUserChatIsPrivate',
];
const newUsersActions = [
    'addUserHiddenFieldsProfile',
    'removeUserHiddenFieldsProfile',
    'loadUserHiddenFieldsProjects',
    'changeUserHiddenFieldProjects',
    'loadUserHiddenFieldsProgress',
    'changeUserHiddenFieldProgress',
    'loadUserChatIsPrivate',
    'changeUserChatIsPrivate',
];

export default {
    name: 'TabSettings',
    components: {
        ModelCheckbox,
        ModelSwitch,
        Folder,
    },
    data: () => ({
        loading: false,
        neededFields: [
            'dateOfBirth',
            'foreignStatusId',
            'activity',
            'gender',
            'about',
            'tel',
            'vk',
            'yt',
            'regEmail',
            'ok',
            'tiktok',
            'zen',
            'telegram',
            'userEducation',
            'userCareers',
            'socialActivity',
        ],
        neededProjectsFields: [
            'nomination',
        ],
        neededProgressFields: [
            'competence',
            'profile',
        ],
        tree: [
            {
                key: 'main',
                title: 'Основные данные',
                type: 'checkbox',
                flex: 3,
                items: [
                    {
                        key: 'dateOfBirth',
                        label: 'Возраст',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'foreignStatusId',
                        label: 'Статус',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'activity',
                        label: 'Сфера деятельности',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'gender',
                        label: 'Пол',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'about',
                        label: 'О себе',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                ],
            },
            {
                key: 'contacts',
                title: 'Контакты и социальные сети',
                type: 'checkbox',
                flex: 4,
                items: [
                    {
                        key: 'tel',
                        label: 'Телефон',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'regEmail',
                        label: 'E-mail',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'vk',
                        label: 'Вконтакте',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'telegram',
                        label: 'Телеграм',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'tiktok',
                        label: 'TikTok',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'zen',
                        label: 'ЯндексДзен',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'ok',
                        label: 'Одноклассники',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'yt',
                        label: 'Youtube',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                ],
            },
            {
                key: 'education',
                title: 'Ваша деятельность',
                type: 'switch',
                flex: 'meta',
                meta: 'Содержание разделов «Документы», «Дополнительные данные», адрес регистрации, место вашего рождения и семейный статус являются конфиденциальной информацией, закрытой от участников платформы.',
                items: [
                    {
                        key: 'userEducation',
                        label: 'Образование',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'userCareers',
                        label: 'Карьера',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                    {
                        key: 'socialActivity',
                        label: 'Социальная активность',
                        value: false,
                        api: 'HiddenFieldProfile',
                    },
                ],
            },
            {
                key: 'activities',
                title: 'Активности на платформе',
                type: 'switch',
                flex: 2,
                items: [
                    {
                        key: 'competence',
                        label: 'Компетенции и навыки',
                        value: false,
                        api: 'HiddenFieldProgress',
                    },
                    // {
                    //     key: 'isPrivate',
                    //     label: 'Связь с вами через чат',
                    //     value: false,
                    //     api: 'ChatIsPrivate',
                    // },
                ],
            },
        ],
        isPrivatePage: false,
        hiddenFieldsProfile: [],
        saveButton: {
            text: 'Сохранить',
            color: '#4663AB',
        },
    }),
    computed: {
        ...mapGetters('newUsers', newUsersGetters),
        ...mapGetters(['userProfileInfo']),
    },
    watch: {
        userProfileInfo(val) {
            this.assembleProfileFields(val);
        },
    },
    async created() {
        this.loading = true;
        await Promise.all([
            await this.loadProfileData(),
            await this.loadUserHiddenFieldsProjects(),
            await this.loadUserHiddenFieldsProgress(),
            await this.loadUserChatIsPrivate(),
        ]);
        this.assembleProfileFields(this.userProfileInfo);
        this.loading = false;
    },
    methods: {
        ...mapActions('newUsers', newUsersActions),
        ...mapActions(['postProfileData', 'loadProfileData']),

        assembleProfileFields(userProfileInfo) {
            if (userProfileInfo && userProfileInfo.hiddenFields) {
                this.isPrivatePage = !!userProfileInfo.isPrivatePage;
                this.hiddenFieldsProfile = userProfileInfo.hiddenFields;
            }
            const neededProfileFields = this.hiddenFieldsProfile.filter(el => this.neededFields.includes(el));
            const neededFields = [...neededProfileFields, ...this.getUserHiddenFieldsProgress, ...this.getUserHiddenFieldsProjects, this.getUserChatIsPrivate ? 'isPrivate' : ''].filter(el => el);
            for (const el of this.tree) {
                for (const item of el.items) {
                    item.value = !neededFields.includes(item.key);
                }
            }
        },
        async updateToApi(value, field, api) {
            this.loading = true;
            if (api !== 'HiddenFieldProfile') {
                const method = `changeUser${api}`;
                const data = { [field]: !value };
                await this[method](data);
            } else {
                const method = `${value ? 'remove' : 'add'}UserHiddenFieldsProfile`;
                await this[method]({
                    userId: this.userProfileInfo.userId,
                    hiddenFields: [field],
                });
            }
            this.loading = false;
        },
        async updateIsPrivatePage() {
            this.loading = true;

            await Promise.all([
                this.postProfileData({ isPrivatePage: this.isPrivatePage }),
                this.groupUpdateProfile({ keys: this.neededFields, flag: !this.isPrivatePage }),
                this.groupUpdateProjects({ keys: this.neededProjectsFields, flag: !this.isPrivatePage }),
                this.groupUpdateProgress({ keys: this.neededProgressFields, flag: !this.isPrivatePage }),
                this.groupUpdateChat({ keys: ['isPrivate'], flag: !this.isPrivatePage }),
            ]);
            this.tree = this.getTreeWithAssembledLeafs(this.tree, [{ key: 'value', value: !this.isPrivatePage }]);
            this.loading = false;
        },

        getTreeWithAssembledLeafs(tree, updatedFields = []) {
            return tree.map(branch => ({
                ...branch,
                items: branch.items.map(leaf => {
                    const data = { ...leaf };
                    updatedFields.forEach(el => {
                        data[el.key] = el.value;
                    });
                    return data;
                }),
            }));
        },

        async groupUpdateProfile({ keys, flag }) {
            const method = `${flag ? 'remove' : 'add'}UserHiddenFieldsProfile`;
            await this[method]({
                userId: this.userProfileInfo.userId,
                hiddenFields: keys,
            });
        },

        async groupUpdateProjects({ keys, flag }) {
            const data = keys.reduce((res, curr) => {
                res[curr] = !flag;
                return res;
            }, {});
            await this.changeUserHiddenFieldProjects(data);
        },

        async groupUpdateProgress({ keys, flag }) {
            const data = keys.reduce((res, curr) => {
                res[curr] = !flag;
                return res;
            }, {});
            await this.changeUserHiddenFieldProgress(data);
        },

        async groupUpdateChat({ keys, flag }) {
            const data = keys.reduce((res, curr) => {
                res[curr] = !flag;
                return res;
            }, {});
            await this.changeUserChatIsPrivate(data);
        },
    },
};
</script>

<style lang='scss' scoped>
@import '~@/styles/rem';

.box {
    background-color: #FFFFFF;
    border-radius: .2rem;
    padding: rem(32);
    display: block;

    @include on-mobile {
        padding: mrem(24) mrem(16);
        margin-top: mrem(16);
        background-color: white;
        box-shadow: 0 mrem(2) mrem(8) rgba(155, 161, 166, 0.23626);
    }
}

h3 {
    margin: 0 0 rem(24);
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(28);
    display: block;

    @include on-mobile {
        margin: 0 0 mrem(24);
        font-size: mrem(22);
        line-height: mrem(30);
    }
}

.block {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &.meta > * {
        flex: 0 50%;

        @include on-mobile {
            flex: 0 100%;
        }
    }
}

.info {
    font-weight: 600;
    font-size: rem(12);
    line-height: rem(20);
    color: #98A0A9;

    @include on-mobile {
        margin-bottom: mrem(16);
        font-size: mrem(16);
        line-height: mrem(24);
    }
}

.item {
    .flex-2 & {
        flex: 0 50%;
    }

    .flex-3 & {
        flex: 0 33%;
    }

    .flex-4 & {
        flex: 0 25%;
    }

    @include on-mobile {
        flex: 0 100% !important;
    }
}

.meta-box {
    padding: 0 0 rem(40);
    display: flex;
    align-items: center;

    @include on-mobile {
        flex-wrap: wrap;
        padding: mrem(24) 0;
    }

    label {
        @include on-mobile {
            margin-right: mrem(10) !important;
        }
    }

    label {
        margin-bottom: 0;
        margin-right: rem(10);
    }

    .tooltip-wrapper {
        position: relative;
    }

    .tooltip-action {
        width: rem(24);
        height: rem(24);
        background-image: url('~@/assets/images/help-outline.svg');
        background-size: 100%;
        cursor: pointer;

        &:hover {
            background-image: url('~@/assets/images/help-inline.svg');
        }

        @include on-mobile {
            width: mrem(26);
            height: mrem(26);
        }
    }

    .tooltip-action:hover + .tooltip-details {
        display: block;
    }

    .tooltip-details {
        display: none;
        position: absolute;
        min-width: rem(210);
        padding: rem(12) rem(14);
        left: rem(30);
        top: 0;
        color: #fff;
        background: #2A2626;
        opacity: 0.9;
        border-radius: rem(4);
        font-size: rem(12);
        line-height: rem(24);

        @include on-mobile {
            min-width: mrem(210);
            padding: mrem(12) mrem(14);
            top: mrem(30);
            left: - mrem(60);
            border-radius: mrem(4);
            font-size: mrem(12);
            line-height: mrem(24);
        }
    }
}
</style>
